<div class="container-contact-our-experts">
  <p>Select from the categories below to guide your submission.</p>

  <hr />

  <form class="m-t-20" [formGroup]="form">
    @if ({
      supportTopic: supportTopic$ | async,
      supportTopicRequest: supportTopicRequest$ | async,
      }; as content) {
      @if (!content.supportTopicRequest?.isPristine) {
        @if (!content.supportTopicRequest?.isLoading) {
          @if (!content.supportTopicRequest?.hasError) {
            @if (content.supportTopicRequest?.options?.length) {
              <ul class="container-options">
                @for (option of content.supportTopic; track option) {
                  <li>
                    <div class="form-group m-0">
                      <label class="m-0" for="radio-{{ option.code }}">
                        <div class="form-check m-0">
                          <input
                            id="radio-{{ option.code }}"
                            class="form-check-input"
                            role="radio"
                            type="radio"
                            aria-checked="true"
                            [value]="option.code"
                            formControlName="supportTopic"
                            (click)="getSubTopics(option)"
                            />
                            <label class="form-check-label form-radio-label" for="radio-{{ option.code }}">
                              {{ option.label }}
                            </label>
                          </div>
                        </label>
                      </div>
                    </li>
                  }
                </ul>
              } @else {
                <p class="text-center ff-bold m-0">
                  {{ 'generic.noContent' | cxTranslate }}
                </p>
              }
            } @else {
              <alert [alert]="alertErrorMessageTopic"></alert>
            }
          } @else {
            <local-loader></local-loader>
          }
        }
      }

      @if ({
        subTopicRequest: subTopic$ | async,
        }; as content) {
        @if (content.subTopicRequest?.subTopic?.options && content.subTopicRequest!.subTopic!.options!.length > 0) {
          <hr />
          <p class="m-b-20">Please choose from the following options:</p>
          <ul class="container-options">
            @for (option of content.subTopicRequest?.subTopic?.options; track option) {
              <li>
                <div class="form-group m-0">
                  <label class="m-0" for="radio-{{ option.code }}">
                    <div class="form-check m-0">
                      <input
                        id="radio-{{ option.code }}"
                        class="form-check-input"
                        role="radio"
                        type="radio"
                        aria-checked="true"
                        [value]="option.code"
                        formControlName="subTopic"
                        (click)="getOption(option)"
                        />
                        <label class="form-check-label form-radio-label" for="radio-{{ option.code }}">
                          {{ option.label }}
                        </label>
                      </div>
                    </label>
                  </div>
                </li>
              }
            </ul>
          }
          @if (content.subTopicRequest?.subTopic?.action) {
            <hr />
            <display-sub-content
              [subTopic]="content.subTopicRequest?.subTopic!"
              [form]="formContact"
              [countries$]="countries$"
              [businessTypes$]="businessTypes$"
              [stateRegions$]="stateRegions$"
              (_onSubmit)="submit()"
            ></display-sub-content>
          }
        }

        @if ({
          subTopicRequest: subTopic$ | async,
          options: options$ | async,
          }; as content) {
          @if (content.subTopicRequest?.subTopic?.options?.length && content.options?.subTopic?.action) {
            <hr />
            <display-sub-content
              [subTopic]="content.options?.subTopic!"
              [form]="formContact"
              [countries$]="countries$"
              [businessTypes$]="businessTypes$"
              [stateRegions$]="stateRegions$"
              (_onSubmit)="submit()"
            ></display-sub-content>
          }
        }
      </form>
    </div>
